module.exports = __webpack_public_path__ + "static/img/banner-品诺蛋糕@2x.b78b336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-品诺蛋糕@2x.png
// module id = vcnA
// module chunks = 1